import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import { fetchFilters } from "flavours/glitch/actions/filters";
import ColumnHeader from "flavours/glitch/components/column_header";
import PageFrame from "flavours/glitch/features/ui/components/page_frame";
import { useAppDispatch, useAppSelector } from "flavours/glitch/store";

const messages = defineMessages({
  heading: { id: "navigation_bar.filters", defaultMessage: "Muted words" },
});

const Filters = ({ multiColumn, embedded }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const filters = useAppSelector(state => state.get("filters"));
  const title = intl.formatMessage(messages.heading);
  const [now] = useState(() => Date.now());

  useEffect(() => {
    dispatch(fetchFilters());
  }, [dispatch]);

  const items = Array.from(filters.values())
    .sort((a, b) => (a.get("title") || "").localeCompare(b.get("title") || ""));

  return (
    <PageFrame embedded={embedded} bindToDocument={!multiColumn} label={title}>
      <ColumnHeader icon='eye-slash' title={title} multiColumn={multiColumn} showBackButton />

      <div className='scrollable filters-page'>
        <div className='filters-page__actions'>
          <Link className='button' to='/filters/new'>
            <FormattedMessage id='filters.new' defaultMessage='New filter' />
          </Link>
        </div>

        {items.length === 0 && (
          <div className='empty-column-indicator'>
            <FormattedMessage id='filters.empty' defaultMessage="You haven't created any filters yet." />
          </div>
        )}

        {items.map(filter => {
          const keywords = (filter.get("keywords") || []).map(k => k.get("keyword")).join(", ");
          const expiresAt = filter.get("expires_at");
          const expired = expiresAt && expiresAt < now;

          return (
            <Link key={filter.get("id")} className='filters-page__item' to={`/filters/${filter.get("id")}`}>
              <strong>{filter.get("title")}</strong>
              {expired && <span className='filters-page__badge'><FormattedMessage id='filters.expired' defaultMessage='expired' /></span>}
              <span className='filters-page__meta'>
                {filter.get("filter_action") === "hide" ? (
                  <FormattedMessage id='filters.action.hide' defaultMessage='Hide completely' />
                ) : (
                  <FormattedMessage id='filters.action.warn' defaultMessage='Hide behind a warning' />
                )}
                {" · "}
                <FormattedMessage id='filters.keyword_count' defaultMessage='{count, plural, one {# keyword} other {# keywords}}' values={{ count: filter.get("keywords")?.size || 0 }} />
              </span>
              {keywords && <span className='filters-page__keywords'>{keywords}</span>}
            </Link>
          );
        })}
      </div>

      <Helmet>
        <title>{title}</title>
        <meta name='robots' content='noindex' />
      </Helmet>
    </PageFrame>
  );
};

Filters.propTypes = {
  multiColumn: PropTypes.bool,
  embedded: PropTypes.bool,
};

export default Filters;
